import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setNavBarMode } from "../api/xoicom.reducer";
import { scrollToTop } from "../utils/utils";

/**
 * Handles page-level navigation setup on mount:
 *   - Scroll to top
 *   - Set navbar mode ("light" or "dark")
 *
 * API fetches are intentionally excluded — each page manages its own data effects.
 *
 * @param {string} navbarMode - "light" or "dark"
 */
export default function usePageSetup(navbarMode) {
  const dispatch = useDispatch();

  useEffect(() => {
    scrollToTop();
    dispatch(setNavBarMode(navbarMode));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
